import EventEmitter from 'eventemitter3'

export const EE = new EventEmitter()